import { SendoutReceivers } from '@app/pages/Sendouts/SendoutReceivers/SendoutReceivers.main';
import { Sendouts } from '@app/pages/Sendouts/SendoutsList/Sendouts.main';

import { SendoutsPageHeader } from './SendoutsList/components/SendoutsPageHeader';

export { Sendouts, SendoutReceivers, SendoutsPageHeader };
